import http from '../../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/salesamplelist',
    selectPage(query) {
        return http({
            url: this.baseurl + '/bscSalesSamplelistSh/selectPage',
            method: 'post',
            params: query
        });
    },
    selectById(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistSh/selectById?id=' + v);
    },
    updateById(query) {
        return http({
            url: this.baseurl + '/bscSalesSamplelistSh/updateById',
            method: 'post',
            data: query
        });
    },
    toDelete(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistSh/toDelete?id=' + v);
    },
    Listed(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistSh/Listed?id=' + v);
    },
    below(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistSh/below?id=' + v);
    },
    showprocategory(v){
        return http.post('/api/swyl/v1/productlevel/productLevel/showprocategory?id='+ v);
    },
    saveS(query){
        return http({
            url: this.baseurl + '/bscSalesSamplelistSh/insert',
            method: 'post',
            params: query
        });
    },
    selectUpdate(v){
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistLog/selectUpdate?id='+ v);
    }
}
